import React from 'react';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';

import { InfoField, ChipBox } from '@occc/ui-design-system';
import { EarningMechanismTotalEligiblePurchaseFragment } from '@occc/graphql';

import { formatProductCounting, formatProductRounding } from '../utils';

interface ITotalEligiblePurchaseProps {
  earningMechanism: EarningMechanismTotalEligiblePurchaseFragment;
}

export const TotalEligiblePurchase: React.FC<ITotalEligiblePurchaseProps> = ({
  earningMechanism,
}) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (pgId: string) => {
      navigate(`/product-groups/${pgId}`);
    },
    [navigate],
  );

  return (
    <Grid container spacing={2}>
      <Grid item sm={6}>
        <InfoField
          disableTypography
          label='Included Product Groups'
          value={
            <ChipBox items={earningMechanism.eligibleProductGroups} onClick={onChipClick} mt={0} />
          }
        />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Count Products By' value={formatProductCounting(earningMechanism)} />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Round Counted Products' value={formatProductRounding(earningMechanism)} />
      </Grid>
    </Grid>
  );
};
